import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {categorysList,categorysAdd,categorysUpdate,categorysDelete,categorysStatus,categorysEdit}=API

const initialState = { 
    data:[],
    singleData:[],
    singleCategorys:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[]
}

const categorysSlice = createSlice({
    name: "categorys",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteCategorys(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setCategorysAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditCategorys(state,action){
          state.singleCategorys=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleCategorys=[]
      },
      setChnageStatus(state,action){
        state.singleData=state.data.filter((item)=>item._id == action.payload)
        state.singleData[0].status=state.singleData[0].status===1?0:state.singleData[0].status===0?1:''
      },
      setEditData(state,action){
          state.editData=action.payload
      }
    },
  });
  
  export const {setEditData,setChnageStatus, setLoading, setMessage,setError,setData,setDeleteLoad,setCategorysAdd,setAfterDeleteCategorys,setEditCategorys,setBlankSingleData} = categorysSlice.actions;
  export default categorysSlice.reducer;

  export const getCategorysData = () => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await categorysList()
      if (res.data.success) {
          dispatch(setData(res.data.data))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const categorysDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await categorysAdd(data)
      if(res.data.success) {
         dispatch(setCategorysAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleCategorysDataAction=(id) =>(dispatch)=>{
              dispatch(setEditCategorys(id))
}
export const blankDataAction=() =>(dispatch)=>{
             dispatch(setBlankSingleData())
}
export const categorysDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await categorysUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const categorysEditAction=(id) => async (dispatch)=>{
  try{
    const res= await categorysEdit(id)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const categorysDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await categorysDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteCategorys(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }

  export const statusChangeAction = (id) => async (dispatch) => {
    dispatch(setDeleteLoad(true));
   try {
   const res= await categorysStatus(id)
    if (res.data.success) {
     dispatch(setChnageStatus(id))
     dispatch(setDeleteLoad(false));
     dispatch(setMessage(res.data.message))
     message.success(res.data?.message);
} else {
   dispatch(setDeleteLoad(false));
   dispatch(setError(res.data.message));
}
} catch (e){
dispatch(setDeleteLoad(false));
dispatch(setError(e.response.data.message));
message.error(e.response.data.message);
}
};